import { CheckIcon } from "@phosphor-icons/react/Check";
import { Button } from "@freightsimple/ui-core/Controls/Button";
import { Heading } from "@freightsimple/ui-core/Typography/Heading";
import { Stack } from "@freightsimple/ui-core/ComponentLayout/Stack";
import { T } from "@freightsimple/ui-core/Typography/T";

interface UploadPhotosAllSetProps {
  /** Photos attached to the shipment during this visit to the page. */
  attachedCount: number;
  onAddMorePhotos: () => void;
}

function describeAttachedCount(count: number): string {
  return count === 1
    ? "1 photo attached to your shipment."
    : `${count} photos attached to your shipment.`;
}

/**
 * Shown after the shipper taps Done. Every photo is already saved by then, so
 * this only confirms it and tells them they can close the page: a page opened
 * from a QR scan can't close its own tab.
 */
export function UploadPhotosAllSet(props: UploadPhotosAllSetProps) {
  return (
    <Stack gap={4} align="center">
      <span className="flex size-16 items-center justify-center rounded-full bg-dark-green text-white shadow-lg">
        <CheckIcon weight="bold" size={36} aria-hidden />
      </span>
      <Stack gap={2} align="center">
        <Heading level={1} size="3xl" align="center">
          You're all set
        </Heading>
        <T align="center" testId="upload-photos-all-set-count">
          {describeAttachedCount(props.attachedCount)}
        </T>
        <T color="secondary" align="center">
          You can close this page.
        </T>
      </Stack>
      <Button
        size="link"
        onClick={props.onAddMorePhotos}
        data-testid="upload-photos-add-more-button"
      >
        Add more photos
      </Button>
    </Stack>
  );
}
